import { apiSlice } from "../../app/api/apiSlice"

export const emailsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        emailPlain: builder.mutation({
            query: emailData => ({
                url: '/emails/plain',
                method: 'POST',
                body: {
                    ...emailData,
                },
            }),
        }),
        emailAttachment: builder.mutation({
            query: emailData => ({
                url: '/emails/attachment',
                method: 'POST',
                body: {
                    ...emailData,
                },
            }),
        }),
    }),
})

export const {
    useEmailPlainMutation,
    useEmailAttachmentMutation,
} = emailsApiSlice
